import { axiosInstance } from ".."

const partnersList = async (querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/customers?showPartner=1&${querry}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default partnersList;